// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"./globalVariables.css\"","headerTitle":"white","fontFamily":"Bebas Neue","defaultBlue":"#00002f"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/App.css
// module id = 13
// module chunks = 0